var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:{'disabled': _vm.disabled},style:({width: _vm.width + 'px', height: _vm.height + 'px', 'line-height': _vm.height - 25 + 'px'}),on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }